export const sectionData = [
    {
        id: 1,
        title: 'Удобно и просто',
        text: 'Сходите в кино, не вставая с дивана: три клика до любого фильма, все новинки кинопроката в зоне действия вашего пульта. Попкорн придется покупать отдельно.',
        src: 'icon-keks.png',
    },
    {
        id: 2,
        title: 'Телевизор у вас в кармане',
        text: 'Захватите кино в дорогу: купите фильм со смартфона и смотрите на любых устройствах.',
        src: 'icon-devices.png',
    },
    {
        id: 3,
        title: 'Удобная оплата',
        text: 'Смотрите сразу — платите в конце месяца. Сто фильмов — одна квитанция: все покупки видны в общем счете за услуги связи. Платите с карты или лицевого счета.',
        src: 'icon-rubl.png',
    },
    {
        id: 4,
        title: 'Кино за копейки',
        text: 'За 150 рублей в месяц — доступ к пяти тысячам фильмов с подпиской Megogo. Сами посчитайте, сколько стоит каждый фильм.',
        src: 'icon-copilka.png',
    },
    {
        id: 5,
        title: 'Новинки в день выхода',
        text: 'Смотрите вместе со всем миром. Мы показываем фильмы вскоре после премьеры, сериалы — в день выхода, а «Игру престолов» — лишь на час позже, чем в Америке.',
        src: 'icon-kino.png',
    },
    {
        id: 6,
        title: 'Легальный контент',
        text: 'Герои говорят теми же голосами, что в прошлом сезоне. Смотрите фильмы от официальных поставщиков в хорошей озвучке и без рекламы онлайн-казино.',
        src: 'icon-copyright.png',
    },
];
